import type { IconData } from '@stacksjs/iconify-core'

export const videoMoviesPlayer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.377 6.85h1.53v18.29h-1.53Zm-1.52 18.29h1.52v1.52h-1.52Zm0-19.81h1.52v1.52h-1.52ZM3.478 26.66h24.38v1.53H3.478Zm16.76-13.71h-1.52v-1.52h-1.531V9.9h-1.52V8.38h-4.57v15.24h4.57v-1.53h1.52v-1.52h1.531v-1.53h1.52v-1.52h1.519v-3.05h-1.519zM3.478 3.81h24.38v1.52H3.478ZM1.947 25.14h1.53v1.52h-1.53Zm0-19.81h1.53v1.52h-1.53ZM.427 6.85h1.52v18.29H.427Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default videoMoviesPlayer
